export default "__VITE_ASSET__DFtOL7xQ__"